import * as layout from "./MainInformations.css";
import * as styles from "./NotesSection.css";

import { clsx } from "clsx";
import { useAtomValue } from "jotai";
import type { JSX } from "react";

import { Separator } from "@frontend/components/atoms/Separator";
import {
  TextEditor,
  plainTextToHtml,
} from "@frontend/components/organisms/TextEditor";
import { useField } from "@frontend/hooks/form";
import { useLingui } from "@lingui/react/macro";

import { projectEditorAtom, projectForm } from "../stores/editor";

const fields = projectForm.fields;

/** Each editor names itself in its toolbar, so no legend sits above it. */
export function NotesSection(): JSX.Element {
  const { t } = useLingui();

  const { type } = useAtomValue(projectEditorAtom);

  const comments = useField(fields.comments);
  const exploitationComments = useField(
    fields.intervention.fields.exploitationComments,
  );

  if ("subscription" === type) {
    return (
      <TextEditor
        fill
        size="sm"
        label={t`Notes`}
        toolbarVariant="ghost"
        value={plainTextToHtml(comments.value ?? "")}
        onValueChange={comments.setValue}
      />
    );
  }

  return (
    <div className={clsx(layout.columns, styles.fill)}>
      <div className={clsx(layout.column, styles.fill)}>
        <TextEditor
          fill
          size="sm"
          label={t`Notes`}
          toolbarVariant="ghost"
          value={plainTextToHtml(comments.value ?? "")}
          onValueChange={comments.setValue}
        />
      </div>

      <Separator orientation="vertical" className={layout.separator} />

      <div className={clsx(layout.column, styles.fill)}>
        <TextEditor
          fill
          size="sm"
          label={t`Operations notes`}
          toolbarVariant="ghost"
          value={plainTextToHtml(exploitationComments.value ?? "")}
          onValueChange={exploitationComments.setValue}
        />
      </div>
    </div>
  );
}
